import axios from "./../../config/axios";

function create(data) {
    return axios().post("/fleet/drivers", data)    
}

function get(id) {
    return axios().get(`/fleet/drivers/${id}`)
}

function update(id, data) {
    return axios().put(`/fleet/drivers/${id}`, data)
}

function remove(id) {
    return axios().delete(`/fleet/drivers/${id}`)
}

function list(params) {
    
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    
    return axios().get(`/fleet/drivers`, {
        params
    })
}

export default {
    create,
    get,
    update,
    remove,
    list
}